import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import classNames from 'classnames';

import SrCalendarTimeRow from 'client/components/SrCalendarTimeRow';

import {
  getAvailableTourDateRange,
  getRangesOfTimes,
  SELF_SCHEDULING_MOMENT_DATE_FORMAT,
} from 'common/tourHelpers';

import branch from 'client/core/branch';

@branch({
  availableTourDates: ['availableTourDates'],
  unavailableTourDates: ['unavailableTourDates'],
})
class SrCalendaryTimeMultiChoice extends Component {
  static propTypes = {
    availableTourDates: PropTypes.array,
    unavailableTourDates: PropTypes.array,
    selectedDate: PropTypes.string.isRequired,
    isSunroomListing: PropTypes.bool,
  };

  static defaultProps = {
    availableTourDates: [],
  };

  constructor(props) {
    super(props);

    this.state = {
      selectedTimes: [],
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.selectedDate !== nextProps.selectedDate) {
      this.setState({
        selectedTimes: [],
      });
    }
  }

  _onSelectTime = (newTime) => {
    const { selectedTimes } = this.state;
    const { onChange } = this.props;
    let newTimes = null;

    if (selectedTimes.includes(newTime)) {
      newTimes = selectedTimes.filter((time) => time !== newTime);
    } else {
      newTimes = [...selectedTimes, newTime];
    }

    this.setState({
      selectedTimes: newTimes,
    });

    onChange(newTimes);
  };

  render() {
    const { selectedTimes } = this.state;
    const { selectedDate, availableTourDates, unavailableTourDates, isSunroomListing } = this.props;

    const date = moment(selectedDate, SELF_SCHEDULING_MOMENT_DATE_FORMAT);
    const availableTourDateRange = getAvailableTourDateRange();

    const timeList = getRangesOfTimes({
      date,
    });

    return (
      <div className={classNames('choiceContainer')}>
        {timeList.map(({ hour, minute, isSmartApartment, isoStringDate }) => (
          <SrCalendarTimeRow
            key={`${hour}:${minute}`}
            hour={hour}
            minute={minute}
            disabled={
              unavailableTourDates.includes(isoStringDate) ||
              (availableTourDateRange.endDate.isAfter(date) &&
                !isSunroomListing &&
                !availableTourDates.includes(isoStringDate))
            }
            isSmartApartment={isSmartApartment}
            selected={selectedTimes.includes(`${hour}:${minute}`)}
            onClick={this._onSelectTime}
          />
        ))}
      </div>
    );
  }
}

SrCalendaryTimeMultiChoice.displayName = 'SrCalendaryTimeMultiChoice';

export default SrCalendaryTimeMultiChoice;
